import { getActivePinia } from "pinia";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useProfileStore } from "@/modules/settings/public";
import { canonicalizeLanguageTag } from "../utils/languageLabel";
/**
 * The locale amounts are formatted in: the user's display language from the profile (fr-FR,
 * fr-CA, en-GB, nl-NL), the i18n locale until the profile has loaded.
 *
 * The i18n locale is not enough on its own: `setLocale` in the i18n plugin normalises fr-CA to
 * fr-FR to pick the translation bundle, and under fr-FR Intl renders a CAD amount as
 * "1 234,56 $CA" where a Canadian reader expects "1 234,56 $".
 */
export function useDisplayLocale() {
    const { locale } = useI18n();
    // CONSTRAINT: resolve the store only when a Pinia is active. The app always has one; component
    // specs that mount a consumer with the real formatters and no Pinia would otherwise throw in
    // setup, and they are entitled to the i18n fallback.
    const pinia = getActivePinia();
    const profileStore = pinia ? useProfileStore(pinia) : null;
    // The profile language is stored as received (OPUS validates it on update only), so a legacy
    // "fr_FR" or an unknown tag can still come back; Intl throws on those and every amount on the
    // page would throw with it. The i18n locale is always a valid tag.
    return computed(() => canonicalizeLanguageTag(profileStore?.profile?.displayLanguage) ?? locale.value);
}
